export default __webpack_public_path__ + "static/media/sh2_10.bf37b7a3.jpg";